// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-q_fP"};